// Lucide -> Nucleo outline-18 mapping. Codemod and LucideIcon shim consume this.
// `root: null` is reserved for brand logos and type-only imports.

export interface NucleoMapping {
	root: string | null
	note?: string
}

export const LUCIDE_TO_NUCLEO_OUTLINE_18 = {
	ALargeSmall: { root: "TextSize" },
	Activity: { root: "ChartActivity" },
	AlarmClock: { root: "AlarmClock" },
	AlertCircle: { root: "CircleWarning" },
	AlertCircleIcon: { root: "CircleWarning" },
	AlertTriangle: { root: "TriangleWarning" },
	Archive: { root: "Archive" },
	ArrowDown: { root: "ArrowDown" },
	ArrowDownNarrowWide: { root: "DescendingSorting" },
	ArrowDownUp: { root: "ArrowUpDownTrail" },
	ArrowLeft: { root: "ArrowLeft" },
	ArrowLeftRight: { root: "ArrowsLeftRightTrail" },
	ArrowRight: { root: "ArrowRight" },
	ArrowRightLeft: { root: "ArrowsLeftRightTrail" },
	ArrowUp: { root: "ArrowUp" },
	ArrowUpCircle: { root: "CircleArrowUp" },
	ArrowUpCircleIcon: { root: "CircleArrowUp" },
	ArrowUpNarrowWide: { root: "AscendingSorting" },
	ArrowUpRight: { root: "ArrowUpRight" },
	AtSign: { root: "AtSign" },
	AtSignIcon: { root: "AtSign" },
	Atom: { root: "Atom" },
	AtomIcon: { root: "Atom" },
	BadgePercent: { root: "Percentage" },
	Ban: { root: "Ban" },
	BarChart3: { root: "ChartBar" },
	BarChartBigIcon: { root: "ChartBar" },
	Bell: { root: "Bell" },
	BellIcon: { root: "Bell" },
	BellOff: { root: "BellSlash" },
	BetweenHorizonalStart: { root: "ArrowRightFromLine" },
	Bold: { root: "TextBold" },
	BoldIcon: { root: "TextBold" },
	Bolt: { root: "Bolt" },
	BookOpen: { root: "BookOpen4" },
	Bot: { root: "Atom", note: "CLAUDE.md rule: replace Bot with Atom" },
	Box: { root: "Box" },
	BoxIcon: { root: "Box" },
	Building2: { root: "Office3" },
	BuildingIcon: { root: "Office3" },
	CalendarClock: { root: "CalendarClock" },
	CalendarClockIcon: { root: "CalendarClock" },
	CalendarDays: { root: "CalendarDays" },
	CaseUpper: { root: "TextSize" },
	Check: { root: "Check" },
	CheckCheck: { root: "CheckDouble" },
	CheckCheckIcon: { root: "CheckDouble" },
	CheckCircle2: { root: "CircleCheck" },
	CheckCircleIcon: { root: "CircleCheck" },
	CheckIcon: { root: "Check" },
	ChevronDown: { root: "ChevronDown" },
	ChevronDownIcon: { root: "ChevronDown" },
	ChevronLeft: { root: "ChevronLeft" },
	ChevronLeftIcon: { root: "ChevronLeft" },
	ChevronRight: { root: "ChevronRight" },
	ChevronRightIcon: { root: "ChevronRight" },
	ChevronUp: { root: "ChevronUp" },
	ChevronUpIcon: { root: "ChevronUp" },
	ChevronUpSquare: { root: "SquareChevronUp" },
	ChevronUpSquareIcon: { root: "SquareChevronUp" },
	ChevronsUpDown: { root: "ChevronExpandY" },
	Circle: { root: "CircleDashed" },
	CircleAlert: { root: "CircleWarning" },
	CircleArrowUp: { root: "CircleArrowUp" },
	CircleDollarSign: { root: "CircleDollar" },
	CircleDot: { root: "CircleDashed" },
	CircleHelp: { root: "CircleQuestion" },
	CircleIcon: { root: "CircleDashed" },
	CircleUserRound: { root: "CircleUser" },
	Clock: { root: "Clock" },
	Cloud: { root: "Cloud" },
	CloudUpload: { root: "CloudUpload" },
	Code: { root: "Code" },
	Code2: { root: "Code2" },
	Code2Icon: { root: "Code2" },
	CodeXml: { root: "Code3" },
	Compass: { root: "Compass" },
	Copy: { root: "Copy" },
	CopyIcon: { root: "Copy" },
	CornerUpLeft: { root: "ArrowCornerUpLeft" },
	CreateIcon: {
		root: null,
		note: "Lucide has no CreateIcon; inspect call site",
	},
	CreditCard: { root: "CreditCard" },
	Database: { root: "Database" },
	DatabaseZap: { root: "Database" },
	DeleteIcon: { root: "Trash" },
	DiamondPlus: { root: "CirclePlus" },
	Download: { root: "ArrowDownToLine" },
	Edit: { root: "Pen" },
	Edit2: { root: "Pen2" },
	Edit2Icon: { root: "Pen2" },
	EditIcon: { root: "Pen" },
	Ellipsis: { root: "Menu" },
	EllipsisIcon: { root: "Menu" },
	EllipsisVertical: { root: "Menu" },
	ExternalLink: { root: "SquareArrowUpRight" },
	Eye: { root: "Eye" },
	EyeIcon: { root: "Eye" },
	EyeOff: { root: "EyeSlash" },
	EyeOffIcon: { root: "EyeSlash" },
	Feather: { root: "PenNib" },
	FileArchiveIcon: { root: "FileZip" },
	FileAudio2Icon: { root: "File" },
	FileCodeIcon: { root: "Code3" },
	FileIcon: { root: "File" },
	FileJson2Icon: { root: "Code3" },
	FilePlus2: { root: "FilePlus" },
	FileSpreadsheet: { root: "Table" },
	FileSpreadsheetIcon: { root: "Table" },
	FileText: {
		root: "Notepad",
		note: "DB rows store FileText as default; shim translates at render time",
	},
	FileTextIcon: { root: "Notepad" },
	Filter: { root: "Filter" },
	Flame: { root: "Flame" },
	FlaskConical: { root: "Flask" },
	FolderClosed: { root: "Folder" },
	FolderIcon: { root: "Folder" },
	Folders: { root: "Folders" },
	GalleryVerticalEnd: { root: "GridLayout" },
	GitBranch: { root: "CodeBranch" },
	GitBranchPlus: { root: "CodeBranch" },
	GitPullRequest: { root: "CodePullRequest" },
	Github: {
		root: null,
		note: "brand logo; use GitHubIcon from @productlane/ui",
	},
	Globe: { root: "Globe" },
	GripVertical: { root: "GripDotsVertical" },
	HardDrive: { root: "HardDrive" },
	Heading1: { root: "Heading1" },
	Heading2: { root: "Heading2" },
	Heading3: { root: "Heading3" },
	HeartHandshake: { root: "HeartHandshake" },
	HelpCircle: { root: "CircleQuestion" },
	History: { root: "ClockTime" },
	Image: { root: "Photo" },
	ImageIcon: { root: "Photo" },
	ImageMinus: { root: "PhotoMinus" },
	ImagePlay: { root: "Photo" },
	ImagePlayIcon: { root: "Photo" },
	ImagePlusIcon: { root: "ImagePlus" },
	Images: { root: "PhotoAlbum" },
	Inbox: { root: "Inbox" },
	InboxIcon: { root: "Inbox" },
	Info: { root: "CircleInfo" },
	InfoIcon: { root: "CircleInfo" },
	ItalicIcon: { root: "TextItalic" },
	KeyRound: { root: "Key" },
	Languages: { root: "Language" },
	Layers: { root: "Layers" },
	LayoutDashboard: { root: "GridLayout" },
	LayoutGrid: { root: "GridLayout" },
	LifeBuoy: { root: "LifeRing" },
	Link: { root: "Link" },
	Link2: { root: "Link2" },
	Link2Off: { root: "Link2Slash" },
	LinkIcon: { root: "Link" },
	List: { root: "BulletList" },
	ListChecks: { root: "ListCheckbox" },
	ListCollapse: { root: "BulletList" },
	ListFilterIcon: { root: "BarsFilter" },
	ListOrdered: { root: "OrderedList" },
	Loader: { root: "Loader" },
	LoaderCircle: { root: "Loader" },
	LockIcon: { root: "Lock" },
	LogOutIcon: { root: "RectLogout" },
	LucideIcon: {
		root: null,
		note: "type-only import; codemod replaces with ComponentType alias",
	},
	LucideProps: {
		root: null,
		note: "type-only import; codemod replaces with SVGProps<SVGSVGElement>",
	},
	Mail: { root: "Envelope" },
	MailCheck: { root: "EnvelopeCheck" },
	MailCheckIcon: { root: "EnvelopeCheck" },
	MailIcon: { root: "Envelope" },
	MailPlus: { root: "EnvelopePlus" },
	MailX: { root: "EnvelopeBan" },
	MailXIcon: { root: "EnvelopeBan" },
	Map: { root: "Map" },
	MapIcon: { root: "Map" },
	Maximize: { root: "ArrowsExpand" },
	Megaphone: { root: "Bullhorn" },
	Menu: { root: "Menu" },
	MenuIcon: { root: "Menu" },
	MessageCircle: { root: "Msg" },
	MessageCircleIcon: { root: "Msg" },
	MessageSquare: { root: "ChatBubble" },
	MessageSquareQuoteIcon: { root: "ChatBubbleQuote" },
	MessageSquareReply: { root: "ChatBubble" },
	MessageSquareShare: { root: "ChatBubbleArrowRight" },
	MessagesSquare: { root: "Msgs" },
	Minimize: { root: "ArrowsExpand" },
	MinusIcon: { root: "Minus" },
	Monitor: { root: "Monitor" },
	MonitorSmartphoneIcon: { root: "Monitor" },
	Moon: { root: "Moon" },
	MoonIcon: { root: "Moon" },
	MoreHorizontal: { root: "Menu" },
	MoreVertical: { root: "Menu" },
	MoreVerticalIcon: { root: "Menu" },
	Newspaper: { root: "Newspaper" },
	NotepadTextIcon: { root: "Notepad" },
	Orbit: { root: "OrbitSparkle" },
	Paintbrush: { root: "Brush" },
	Palette: { root: "Palette" },
	PanelLeft: { root: "SidebarLeft" },
	PanelRight: { root: "SidebarRight" },
	Paperclip: { root: "Paperclip" },
	Pause: { root: "MediaPause" },
	PenIcon: { root: "Pen" },
	PenLineIcon: { root: "PenWriting" },
	Pencil: { root: "Pencil" },
	PencilLine: { root: "PenWriting" },
	PencilLineIcon: { root: "PenWriting" },
	Play: { root: "MediaPlay" },
	Plus: { root: "Plus" },
	PlusCircleIcon: { root: "CirclePlus" },
	PlusIcon: { root: "Plus" },
	Radio: { root: "Radio" },
	RefreshCcw: { root: "ArrowsRotateCenter" },
	RefreshCw: { root: "ArrowsRotateCenter" },
	Repeat: { root: "Repeat" },
	Reply: { root: "ArrowTurnLeft" },
	RotateCcwSquare: { root: "ArrowsRotateCenter" },
	Rss: { root: "Podcast" },
	Scroll: { root: "Scroll" },
	Search: { root: "Magnifier" },
	SearchIcon: { root: "Magnifier" },
	Send: { root: "PaperPlane" },
	Settings: { root: "Gear" },
	ShieldCheck: { root: "ShieldCheck" },
	Slack: {
		root: null,
		note: "brand logo; use SlackIconGray from @productlane/ui",
	},
	SlackIcon: {
		root: null,
		note: "brand logo; use SlackIconGray from @productlane/ui",
	},
	SlidersHorizontal: { root: "Sliders" },
	SortDesc: { root: "DescendingSorting" },
	SquareArrowOutUpRight: { root: "SquareArrowUpRight" },
	SquareArrowOutUpRightIcon: { root: "SquareArrowUpRight" },
	SquareAsterisk: { root: "Asterisk" },
	SquareCheckIcon: { root: "BoxCheck" },
	StrikethroughIcon: { root: "TextStrikethrough" },
	Sun: { root: "Sun" },
	SunIcon: { root: "Sun" },
	Table: { root: "Table" },
	TableIcon: { root: "Table" },
	Tag: { root: "Tag" },
	Tags: { root: "Tags" },
	Target: { root: "Bullseye" },
	ThumbsDown: { root: "ThumbsDown" },
	ThumbsUp: { root: "ThumbsUp" },
	ToggleLeft: { root: "Toggle" },
	ToggleRight: { root: "Toggle2" },
	Trash: { root: "Trash" },
	Trash2: { root: "Trash2" },
	Trash2Icon: { root: "Trash2" },
	TrashIcon: { root: "Trash" },
	TrendingUpIcon: { root: "ChartTrendUp" },
	TriangleAlertIcon: { root: "TriangleWarning" },
	UndoIcon: { root: "ArrowTurnLeft" },
	UnlinkIcon: { root: "LinkSlash" },
	Upload: { root: "ArrowUpFromLine" },
	UploadCloudIcon: { root: "CloudUpload" },
	UploadIcon: { root: "ArrowUpFromLine" },
	User: { root: "User" },
	User2: { root: "User" },
	UserCheck: { root: "UserCheck" },
	UserCheckIcon: { root: "UserCheck" },
	UserCircle2Icon: { root: "CircleUser" },
	UserCog: { root: "UserSettings" },
	UserIcon: { root: "User" },
	UserPen: { root: "UserPen" },
	UserPlus: { root: "UserPlus" },
	UserX: { root: "UserXmark" },
	Users: { root: "Users" },
	UsersIcon: { root: "Users" },
	Video: { root: "Video" },
	VideoIcon: { root: "Video" },
	Volume1: { root: "VolumeMinus" },
	Volume2: { root: "Volume" },
	VolumeX: { root: "VolumeOff" },
	Wand2: { root: "MagicWand" },
	Workflow: { root: "Workflow" },
	Wrench: { root: "Wrench" },
	X: { root: "Xmark" },
	XCircle: { root: "CircleXmark" },
	XIcon: { root: "Xmark" },
	Youtube: { root: "Video" },
	YoutubeIcon: { root: "Video" },
	Zap: { root: "Bolt" },
} satisfies Record<string, NucleoMapping>

export type LucideIconName = keyof typeof LUCIDE_TO_NUCLEO_OUTLINE_18
